<script>
import {useStore} from "vuex";
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import DatePicker from 'vue3-persian-datetime-picker'
export default {
  name: "MyProfile",
  components: {LoadingPage , DatePicker},

  setup(){

    let store = useStore()
    let loading = ref(false)

    let guilds = ref([])

    let old_profile = store.state.profile
    let states = ref([])
    let cities = ref([])

    let new_profile = ref({
      type: old_profile.type,
      name: old_profile.name,
      // 'نام شرکت'
      shopname: old_profile.shopname,
      phone: old_profile.phone,
      prov_id: old_profile.prov_id,
      city_id: old_profile.city_id,
      category_id: old_profile.category_id,
      // 'کد پستی'
      codepost: old_profile.codepost,
      address: old_profile.address,
      // 'تلفن ثابت'
      telephone: old_profile.telephone,
      email: old_profile.email,
      website: old_profile.website,
      // 'کد ملی'
      codeid: old_profile.codeid,
      // 'تاریخ تولد/تاسیس'
      birthday: old_profile.birthday,
      // 'شناسه ملی شرکت'
      company_codeid: old_profile.company_codeid,
      // 'شماره اقتصادی شرکت'
      company_enum: old_profile.company_enum,
      // 'نام نمایشگاه شرکت'
      company_ename: old_profile.company_ename,
      // 'تاریخ روزنامه رسمی'
      company_date: old_profile.company_date,
      // 'شماره روزنامه رسمی'
      company_number: old_profile.company_number,
      // 'نام معرف'
      company_ref_name: old_profile.company_ref_name,
      // 'شماره معرف'
      company_ref_phone: old_profile.company_ref_phone,
      // 'ایمیل معرف'
      company_ref_email: old_profile.company_ref_email,
    })

    for (let key in new_profile.value) {
      if (new_profile.value[key] === null) {
        new_profile.value[key] = "";
      }
    }


    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'all_guild'}, 'info').then((res) => {

        loading.value = true
        guilds.value = res.data
        get_country()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        change_state(true)

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }

    function change_state(first) {

      states.value.forEach((item)=>{
        if (item.id == new_profile.value.prov_id){
          cities.value = item.city
          if (!first) new_profile.value.city_id = item.city[0].id
        }
      })

    }

    function update_profile() {

      if (new_profile.value.type === 'real' && new_profile.value.name.trim().length === 0){Swals.Warning('لطفا نام و نام خانوادگی خود را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.shopname.trim().length === 0){Swals.Warning('لطفا نام شرکت را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.company_enum.trim().length === 0){Swals.Warning('لطفا شماره اقتصادی شرکت را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.company_codeid.trim().length === 0){Swals.Warning('لطفا شناسه ملی شرکت را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.codepost.trim().length === 0){Swals.Warning('لطفا کد پستی شرکت را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.address.trim().length === 0){Swals.Warning('لطفا آدرس شرکت را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.birthday.length === 0 ){Swals.Warning('لطفا تاریخ تاسیس شرکت را انتخاب کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.company_ref_name.trim().length === 0){Swals.Warning('لطفا نام و نام خانوادگی معرف خود را وارد کنید!');return false}
      if (new_profile.value.type === 'legal' && new_profile.value.company_ref_phone.length === 0){Swals.Warning('لطفا شماره همراه معرف خود را وارد کنید!');return false}


      loading.value = true
      FreeWorld.Heisenberg(new_profile.value , 'update_profile' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          if (new_profile.value.codeid.length === 0) new_profile.value.codeid = null
          if (new_profile.value.codepost.length === 0) new_profile.value.codepost = null
          store.commit('set_profile' , new_profile.value)
          Swals.Done('پروفایل شما با موفقیت ویرایش شد' , 'HomePage')
        }else{
          Swals.Fault('متاسفانه پروفایل شما ویرایش نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , update_profile)
      })

    }

    return{

      loading,
      new_profile,
      update_profile,
      states,
      cities,
      change_state,
      guilds,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" v-if="new_profile.type === 'real'" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white d-flex align-items-center justify-content-between">
      <div @click="new_profile.type = 'legal'" class="d-flex justify-content-center align-items-center bg-color-light rounded-4 p-2">
        <p class="font-color font-5 font-bold">تبدیل به شخص حقوقی</p>
        <img class="ml-1" src="../assets/img/change.png" style="width: 20px;height: 20px">
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">پروفایل من</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body w-100 animate__animated animate__fadeIn">

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">صنف</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <select v-model="new_profile.category_id" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center">
          <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <input v-model="new_profile.name" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره همراه</p>
        </div>
        <div class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center text-disabled font-bold">{{ new_profile.phone }}</div>
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <select v-model="new_profile.prov_id" @change="change_state(false)" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center">
          <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <select v-model="new_profile.city_id" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center">
          <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد ملی</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <input v-model="new_profile.codeid" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" placeholder="تکمیل نشده است" maxlength="10" type="tel">
      </div>

      <div class="mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی</p>
          <img src="../assets/img/pencil.png" class="me-2 mb-2" style="width: 15px;height: 15px">
        </div>
        <input v-model="new_profile.codepost" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" placeholder="تکمیل نشده است" type="text">
      </div>

    </div>
    <br>
      <div class="w-100 max_width p-body mt-5">
      <v-btn @click="update_profile" class="p-3 w-100 h-100 border-0 shadow-custom mb-3 rounded-3 bg-color text-white">ثبت</v-btn>
      </div>

  </div>

  <div id="main" v-if="new_profile.type === 'legal'" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white d-flex align-items-center">
<!--        <img @click="new_profile.type = 'real'" class="ml-1" src="../assets/img/close.png" style="width: 15px;height: 15px">-->

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">ثبت نام</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body w-100 animate__animated animate__fadeIn">
      <div class="mt-3">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام شرکت *</p>
        <input v-model="new_profile.shopname" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text"
               placeholder="فروشگاه شما در اپلیکیشن با این نام نمایش داده میشود">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره اقتصادی شرکت *</p>
        <input v-model="new_profile.company_enum" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شناسه ملی شرکت *</p>
        <input v-model="new_profile.company_codeid" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی شرکت *</p>
        <input v-model="new_profile.codepost" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4 d-flex justify-content-center align-items-center">
        <div class="w-50">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان *</p>
          <select v-model="new_profile.prov_id" class="text-center w-100 border-0 shadow-custom  bg-white py-2 px-1 rounded-4">
            <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <div class="w-50 me-2">
          <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر *</p>
          <select v-model="new_profile.city_id" class="text-center w-100 border-0 shadow-custom bg-white py-2 px-1 rounded-4">
            <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">آدرس شرکت / فروشگاه *</p>
        <textarea v-model="new_profile.address" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2"></textarea>
      </div>


      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تلفن ثابت</p>
        <input v-model="new_profile.telephone" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-3">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
        <input v-model="new_profile.email" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">وب سایت</p>
        <input v-model="new_profile.website" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام نمایشگاه شرکت</p>
        <input v-model="new_profile.company_ename" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">دسته بندی فعالیت *</p>
        <select v-model="new_profile.category_id" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center">
          <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره روزنامه رسمی</p>
        <input v-model="new_profile.company_number" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ روزنامه رسمی</p>
        <input v-model="new_profile.company_date" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ تاسیس *</p>
        <div class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center">
          <date-picker class="text-center border-0" v-model="new_profile.birthday"></date-picker>
        </div>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام مدیر عامل</p>
        <input v-model="new_profile.name" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <p class="mt-5 font-color font-3 font-bold">نماینده معرفی شده</p>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی *</p>
        <input v-model="new_profile.company_ref_name" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره موبایل *</p>
        <input v-model="new_profile.company_ref_phone" onkeydown="return event.key !== ' '" maxlength="11" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
        <input v-model="new_profile.company_ref_email" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text" >
      </div>

      <v-btn @click="update_profile" class="h-100 py-3 mt-4 mb-3 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>
    </div>
  </div>

</template>


<style scoped>

</style>